export const decimalFormat = (value: number, decimals: number): string => {
  return new Intl.NumberFormat("nl-NL", {
    style: "decimal",
    minimumFractionDigits: decimals
  }).format(value);
};
